import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/tailwind.css'
import axios from 'axios'

// Инициализация CSRF токена при загрузке приложения
async function initCSRF() {
  try {
    await axios.get('/api/csrf/', { withCredentials: true })
  } catch (error) {
  }
}

// Инициализируем CSRF токен перед монтированием приложения
initCSRF().then(() => {
  createApp(App).use(router).use(i18n).mount('#app')
}) 